const GUEST_STORAGE_KEY = 'muaazon:wishlist:v1';
let STORAGE_KEY = GUEST_STORAGE_KEY;
let accountMergeDone = false;

function readAccountSeed() {
  try {
    const node = document.getElementById('MuaazonWishlistAccountSeed');
    if (!node) return { customerId: null, loginUrl: '/account/login', accountUrl: '/account', metafieldItems: [] };
    const parsed = JSON.parse(node.textContent || '{}');
    return {
      customerId: parsed.customerId ?? null,
      loginUrl: parsed.loginUrl || '/account/login',
      accountUrl: parsed.accountUrl || '/account',
      metafieldItems: Array.isArray(parsed.metafieldItems) ? parsed.metafieldItems : []
    };
  } catch {
    return { customerId: null, loginUrl: '/account/login', accountUrl: '/account', metafieldItems: [] };
  }
}

function resolveStorageKey() {
  const customerId = readAccountSeed().customerId;
  return customerId ? `${GUEST_STORAGE_KEY}:customer:${customerId}` : GUEST_STORAGE_KEY;
}

function mergeWishlistSources() {
  if (accountMergeDone) return;
  accountMergeDone = true;
  const seed = readAccountSeed();
  STORAGE_KEY = resolveStorageKey();
  if (!seed.customerId) return;
  const guestItems = normalizeItems(parseArray(globalThis.localStorage?.getItem(GUEST_STORAGE_KEY)));
  const accountItems = normalizeItems(parseArray(globalThis.localStorage?.getItem(STORAGE_KEY)));
  const metafieldItems = normalizeItems(Array.isArray(seed.metafieldItems) ? seed.metafieldItems : parseArray(seed.metafieldItems));
  const merged = normalizeItems([...metafieldItems, ...accountItems, ...guestItems]);
  try {
    globalThis.localStorage?.setItem(STORAGE_KEY, JSON.stringify(merged));
    if (guestItems.length) globalThis.localStorage?.removeItem(GUEST_STORAGE_KEY);
  } catch {}
}

const CART_UPDATE_EVENT = 'shopify:cart:lines-update';
const WISHLIST_TOGGLE_SELECTOR = '[data-saved-product-toggle][data-saved-list="wishlist"]';
const WISHLIST_TRIGGER_SELECTOR = '[data-commerce-drawer-trigger="WishlistDrawer"], .mz-site-header a[href*="/wishlist"], .msg-site-header a[href="/pages/wishlist"], .msg-mobile-rail a[href="/pages/wishlist"]';
const ADDED_FEEDBACK_MS = 1400;

function parseArray(value) {
  try {
    const parsed = JSON.parse(value || '[]');
    return Array.isArray(parsed) ? parsed.filter((item) => item && typeof item === 'object') : [];
  } catch { return []; }
}

function identity(item) {
  return `${String(item?.productId ?? '')}:${String(item?.variantId ?? '')}`;
}

function normalizeItems(items) {
  const seen = new Set();
  const normalized = [];
  for (const item of Array.isArray(items) ? items : []) {
    const key = identity(item);
    if (key === ':' || seen.has(key)) continue;
    seen.add(key);
    normalized.push(item);
  }
  return normalized;
}

function parseObject(value) {
  if (!value) return null;
  try {
    const parsed = typeof value === 'string' ? JSON.parse(value) : value;
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : null;
  } catch { return null; }
}

function readItems() {
  try { return normalizeItems(parseArray(globalThis.localStorage?.getItem(STORAGE_KEY))); }
  catch { return []; }
}

function emitWishlistChange() {
  try { globalThis.dispatchEvent(new Event('storage')); } catch {}
  try { document.dispatchEvent(new CustomEvent('muaazon:wishlist:changed', { detail: { count: readItems().length } })); } catch {}
}

function writeItems(items) {
  try {
    const normalized = normalizeItems(items);
    globalThis.localStorage?.setItem(STORAGE_KEY, JSON.stringify(normalized));
    emitWishlistChange();
    return true;
  } catch { return false; }
}

function announce(message, alert = false) {
  const region = document.getElementById(alert ? 'ThemeAlertRegion' : 'ThemeLiveRegion');
  if (region) region.textContent = String(message || '').slice(0, 240);
}

function selectedVariantId(root, fallback = '') {
  return String(
    root?.querySelector?.('[data-product-card-variant-id]')?.value
    || root?.querySelector?.('form[action*="/cart/add"] [name="id"]')?.value
    || fallback
    || ''
  );
}

function selectedPrice(root, fallback = '') {
  return String(
    root?.querySelector?.('[data-product-card-price-current]')?.textContent?.trim()
    || root?.querySelector?.('[data-variant-region="price"]')?.textContent?.trim()
    || fallback
    || ''
  );
}

function selectedImage(root, fallback = '') {
  const cardImage = root?.querySelector?.('.product-card__image--primary');
  const selectedGalleryImage = root?.querySelector?.('[data-gallery-slide][data-gallery-selected="true"] img');
  const galleryImage = selectedGalleryImage || root?.querySelector?.('[data-gallery-slide] img');
  return String(cardImage?.currentSrc || cardImage?.src || galleryImage?.currentSrc || galleryImage?.src || fallback || '');
}

function variantUrl(value, variantId) {
  try {
    const url = new URL(String(value ?? ''), globalThis.location?.origin ?? 'https://example.invalid');
    if (variantId) url.searchParams.set('variant', variantId);
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return String(value ?? '');
  }
}

function snapshotFromWishlistToggle(toggle) {
  const root = toggle?.closest?.('[data-product-card], [data-variant-root], .saved-product-card') ?? toggle?.parentElement;
  const variantId = selectedVariantId(root, toggle?.dataset?.productVariantId);
  const productLink = root?.querySelector?.('[data-product-card-link], .saved-product-card__title a');
  const title = String(
    toggle?.dataset?.productTitle
    || root?.querySelector?.('.product-card__title a, .saved-product-card__title a, [data-variant-region="product-copy"] h1, [data-variant-region="product-copy"] h2')?.textContent?.trim()
    || 'Item'
  );
  const productId = String(toggle?.dataset?.productId ?? root?.dataset?.productId ?? '');
  const handle = String(toggle?.dataset?.productHandle ?? root?.dataset?.productHandle ?? '');
  const rawUrl = String(toggle?.dataset?.productUrl ?? productLink?.getAttribute?.('href') ?? root?.dataset?.productUrl ?? '');
  return {
    productId,
    handle,
    title,
    url: variantUrl(rawUrl, variantId),
    variantId,
    price: selectedPrice(root, toggle?.dataset?.productPrice),
    image: selectedImage(root, toggle?.dataset?.productImage),
    availability: String(root?.querySelector?.('[data-product-availability]')?.textContent?.trim() ?? ''),
    savedAt: Date.now(),
  };
}

function syncWishlistToggles() {
  const items = readItems();
  for (const toggle of document.querySelectorAll?.(WISHLIST_TOGGLE_SELECTOR) ?? []) {
    const item = snapshotFromWishlistToggle(toggle);
    if (!item.productId) continue;
    const active = items.some((candidate) => identity(candidate) === identity(item));
    const pressed = String(active);
    if (toggle.getAttribute('aria-pressed') !== pressed) toggle.setAttribute('aria-pressed', pressed);
    if (toggle.dataset.savedActive !== pressed) toggle.dataset.savedActive = pressed;
    const nextAriaLabel = active ? `Remove ${item.title} from wishlist` : `Save ${item.title} to wishlist`;
    if (toggle.getAttribute('aria-label') !== nextAriaLabel) toggle.setAttribute('aria-label', nextAriaLabel);
    const label = toggle.querySelector?.('[data-saved-product-label]');
    if (label) {
      const nextLabel = active ? 'Saved' : 'Wishlist';
      if (label.textContent !== nextLabel) label.textContent = nextLabel;
    }
  }
}

function toggleWishlistItem(toggle) {
  const snapshot = snapshotFromWishlistToggle(toggle);
  if (!snapshot.productId || !snapshot.variantId) {
    announce('This item cannot be saved to your wishlist right now.', true);
    return false;
  }

  const items = readItems();
  const key = identity(snapshot);
  const index = items.findIndex((item) => identity(item) === key);
  let message;
  if (index >= 0) {
    items.splice(index, 1);
    message = `${snapshot.title} removed from wishlist.`;
  } else {
    items.unshift(snapshot);
    message = `${snapshot.title} added to wishlist.`;
  }

  if (!writeItems(items)) {
    announce('Wishlist storage is unavailable. Please try again.', true);
    return false;
  }

  mergeWishlistSources();
syncWishlistToggles();
  syncWishlistCounts();
  announce(message);
  return true;
}

function ensureBubble(trigger) {
  if (!trigger) return null;
  if (!trigger.dataset.wishlistBaseLabel) {
    // A different wishlist module may have already appended the count.
    // Derive the permanent label once; never turn a dynamic count into the base.
    const currentLabel = String(trigger.getAttribute('aria-label') || 'Wishlist');
    trigger.dataset.wishlistBaseLabel = currentLabel.replace(/(?:,\s*\d+\s+saved\s+items?)+$/gi, '').trim() || 'Wishlist';
  }
  let bubble = trigger.querySelector?.('[data-wishlist-count-bubble]');
  if (bubble) return bubble;
  bubble = document.createElement('span');
  bubble.className = trigger.classList?.contains('mz-site-header__action')
    ? 'mz-site-header__badge wishlist-count-bubble'
    : 'wishlist-count-bubble';
  bubble.dataset.wishlistCountBubble = '';
  bubble.setAttribute('aria-hidden', 'true');
  bubble.hidden = true;
  const value = document.createElement('span');
  value.dataset.wishlistCount = '';
  value.textContent = '0';
  bubble.append(value);
  trigger.append(bubble);
  return bubble;
}

function syncWishlistCounts() {
  const count = readItems().length;
  for (const trigger of document.querySelectorAll?.(WISHLIST_TRIGGER_SELECTOR) ?? []) {
    const bubble = ensureBubble(trigger);
    const value = bubble?.querySelector?.('[data-wishlist-count]');
    if (value) value.textContent = String(count);
    if (bubble) bubble.hidden = count === 0;
    const base = trigger.dataset.wishlistBaseLabel || 'Wishlist';
    trigger.setAttribute('aria-label', count > 0 ? `${base}, ${count} saved ${count === 1 ? 'item' : 'items'}` : base);
  }
  for (const node of document.querySelectorAll?.('[data-saved-products-page][data-saved-list="wishlist"] [data-saved-products-count]') ?? []) node.textContent = String(count);
  return count;
}

function cartEndpoint(endpoint) {
  const root = String(globalThis.Shopify?.routes?.root ?? '/').replace(/\/?$/, '/');
  return `${root}${String(endpoint || '').replace(/^\//, '')}`;
}

async function postCart(endpoint, body) {
  const response = await fetch(cartEndpoint(endpoint), {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  let payload = null;
  try { payload = await response.json(); } catch {}
  if (!response.ok) {
    const message = typeof payload?.description === 'string' && payload.description.trim() ? payload.description.trim() : 'Unable to update the cart. Please try again.';
    throw new Error(message.slice(0, 240));
  }
  return payload ?? {};
}

function notifyCartEngine(operation) {
  document.dispatchEvent(new CustomEvent(CART_UPDATE_EVENT, { detail: { promise: operation } }));
}

function normalizeQuantity(value, fallback = 1) {
  const parsed = Number.parseInt(String(value ?? ''), 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
}

function snapshotFromCartLine(line) {
  const input = line?.querySelector?.('[data-cart-quantity-input]');
  return {
    productId: String(line?.dataset?.productId ?? ''),
    handle: String(line?.dataset?.productHandle ?? ''),
    title: String(line?.dataset?.productTitle ?? ''),
    url: String(line?.dataset?.productUrl ?? ''),
    variantId: String(line?.dataset?.variantId ?? ''),
    price: String(line?.dataset?.productPrice ?? ''),
    image: String(line?.dataset?.productImage ?? ''),
    availability: String(line?.dataset?.productAvailability ?? ''),
    quantity: normalizeQuantity(input?.value ?? line?.dataset?.cartQuantity, 1),
    sellingPlanId: String(line?.dataset?.sellingPlanId ?? ''),
    properties: parseObject(line?.dataset?.lineProperties) ?? undefined,
    savedAt: Date.now(),
  };
}

function persistWishlistItem(snapshot) {
  if (!snapshot?.productId || !snapshot?.variantId) return false;
  const items = readItems();
  const key = identity(snapshot);
  const index = items.findIndex((item) => identity(item) === key);
  const normalized = { ...(index >= 0 ? items[index] : {}), ...snapshot, savedAt: Date.now() };
  if (index >= 0) items.splice(index, 1);
  items.unshift(normalized);
  return writeItems(items);
}

function removeWishlistItem(productId, variantId) {
  const items = readItems();
  const key = `${String(productId ?? '')}:${String(variantId ?? '')}`;
  const next = items.filter((item) => identity(item) !== key);
  if (next.length === items.length) return false;
  return writeItems(next);
}

function wishlistRecord(productId, variantId) {
  const key = `${String(productId ?? '')}:${String(variantId ?? '')}`;
  return readItems().find((item) => identity(item) === key) ?? null;
}

function cardMetadata(card) {
  const remove = card?.querySelector?.(WISHLIST_TOGGLE_SELECTOR);
  if (!remove) return null;
  return {
    productId: String(remove.dataset?.productId ?? ''),
    variantId: String(remove.dataset?.productVariantId ?? ''),
    title: String(remove.dataset?.productTitle ?? card.querySelector?.('.saved-product-card__title')?.textContent?.trim() ?? 'Item'),
  };
}

function syncWishlistAtcButton(card, button) {
  if (!button || button.dataset.compatBusy === 'true') return;
  const availability = String(card?.querySelector?.('[data-saved-product-availability]')?.textContent ?? '').trim().toLowerCase();
  const soldOut = availability === 'sold out' || availability.includes('unavailable');
  button.disabled = soldOut;
  button.setAttribute('aria-disabled', soldOut ? 'true' : 'false');
  button.textContent = soldOut ? 'Sold out' : 'Add to cart';
}

function decorateWishlistCards() {
  for (const card of document.querySelectorAll?.('[data-saved-products-page][data-saved-list="wishlist"] .saved-product-card') ?? []) {
    const actions = card.querySelector?.('.saved-product-card__actions');
    const metadata = cardMetadata(card);
    if (!actions || !metadata?.variantId) continue;
    let button = actions.querySelector?.('[data-wishlist-add-to-cart]');
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'button wishlist-add-to-cart';
      button.dataset.wishlistAddToCart = '';
      actions.prepend(button);
    }
    button.setAttribute('aria-label', `Add ${metadata.title || 'item'} to cart`);
    syncWishlistAtcButton(card, button);
  }
}

function scheduleUiSync() {
  queueMicrotask(() => { syncWishlistToggles(); syncWishlistCounts(); decorateWishlistCards(); });
  setTimeout(() => { syncWishlistToggles(); decorateWishlistCards(); }, 250);
}

async function saveForLater(button) {
  const line = button.closest?.('[data-cart-line]');
  if (!line || button.disabled || button.dataset.compatBusy === 'true') return;
  const snapshot = snapshotFromCartLine(line);
  const lineKey = String(line.dataset?.lineKey ?? '');
  if (!snapshot.productId || !snapshot.variantId || !lineKey) {
    announce('This item cannot be saved for later right now.', true);
    return;
  }

  button.dataset.compatBusy = 'true';
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  const originalLabel = button.textContent;
  button.textContent = 'Saving…';

  if (!persistWishlistItem(snapshot)) {
    delete button.dataset.compatBusy;
    button.disabled = false;
    button.removeAttribute('aria-busy');
    button.textContent = originalLabel;
    announce('Wishlist storage is unavailable. The item was kept in your cart.', true);
    return;
  }

  syncWishlistCounts();
  const operation = postCart('cart/change.js', { id: lineKey, quantity: 0 });
  notifyCartEngine(operation);
  try {
    await operation;
    announce(`${snapshot.title || 'Item'} saved for later.`);
  } catch (error) {
    delete button.dataset.compatBusy;
    button.disabled = false;
    button.removeAttribute('aria-busy');
    button.textContent = 'Saved — still in cart';
    announce(`${snapshot.title || 'Item'} was saved, but could not be removed from the cart. ${error?.message ?? ''}`.trim(), true);
  }
}

async function addWishlistItemToCart(button) {
  if (button.disabled || button.dataset.compatBusy === 'true') return;
  const card = button.closest?.('.saved-product-card');
  const metadata = cardMetadata(card);
  if (!card || !metadata?.variantId) return;
  const variantId = Number(metadata.variantId);
  if (!Number.isInteger(variantId) || variantId <= 0) {
    announce('This saved variant can no longer be added to cart.', true);
    return;
  }

  const record = wishlistRecord(metadata.productId, metadata.variantId) ?? {};
  const item = { id: variantId, quantity: normalizeQuantity(record.quantity, 1) };
  const properties = parseObject(record.properties);
  if (properties && Object.keys(properties).length > 0) item.properties = properties;
  if (record.sellingPlanId) item.selling_plan = String(record.sellingPlanId);

  button.dataset.compatBusy = 'true';
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  button.textContent = 'Adding…';

  const operation = postCart('cart/add.js', { items: [item] });
  notifyCartEngine(operation);
  try {
    await operation;
    const removed = removeWishlistItem(metadata.productId, metadata.variantId);
    if (removed) {
      announce(`${metadata.title || 'Item'} added to cart and removed from wishlist.`);
      scheduleUiSync();
      return;
    }
    button.textContent = 'Added ✓';
    announce(`${metadata.title || 'Item'} was added to cart, but its wishlist entry could not be removed.`, true);
    setTimeout(() => {
      if (!button.isConnected) return;
      delete button.dataset.compatBusy;
      button.removeAttribute('aria-busy');
      syncWishlistAtcButton(card, button);
    }, ADDED_FEEDBACK_MS);
  } catch (error) {
    delete button.dataset.compatBusy;
    button.removeAttribute('aria-busy');
    button.disabled = false;
    button.textContent = 'Add to cart';
    announce(error?.message ?? 'Unable to add this item to cart.', true);
    syncWishlistAtcButton(card, button);
  }
}

document.addEventListener('click', (event) => {
  const toggle = event.target?.closest?.(WISHLIST_TOGGLE_SELECTOR);
  if (!toggle) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  toggleWishlistItem(toggle);
}, { capture: true });

document.addEventListener('click', (event) => {
  const save = event.target?.closest?.('[data-cart-save-for-later]');
  if (save) {
    event.preventDefault();
    event.stopImmediatePropagation();
    void saveForLater(save);
    return;
  }
  const add = event.target?.closest?.('[data-wishlist-add-to-cart]');
  if (add) {
    event.preventDefault();
    event.stopImmediatePropagation();
    void addWishlistItemToCart(add);
  }
});

globalThis.addEventListener('storage', (event) => {
  if (!event?.key || event.key === STORAGE_KEY || event.key === GUEST_STORAGE_KEY || event.key.startsWith(`${GUEST_STORAGE_KEY}:customer:`)) scheduleUiSync();
});
document.addEventListener('muaazon:wishlist:changed', scheduleUiSync);
document.addEventListener('shopify:section:load', scheduleUiSync);
document.addEventListener('variant:changed', scheduleUiSync);

syncWishlistToggles();
syncWishlistCounts();
decorateWishlistCards();
setTimeout(scheduleUiSync, 0);
